import React from 'react';
import { 
    List, 
    Datagrid,
    TextField, 
    DateField,
    EditButton,
    ShowButton,
    ListButton,
    CardActions,
    TextInput,
    DateInput,
    Filter,
    SelectInput
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import ErrorBoundary from '../ErrorBoundary';


const listStyles = {
    actions: {
        backgroundColor: 'Lavender',
    },
    header: {
        backgroundColor: '#def',
        fontWeight: 'bold',
    },
};

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};




const PhysicalActions = ({...props}) => (

    <CardActions style={cardActionStyle}>
        <ListButton basePath={'./logs'} label="List" />
    </CardActions>
);

export const LogFilter = props => (
    <Filter {...props}>
        <SelectInput source="app" lable ='Resources' allowEmpty alwaysOn emptyValue="" choices={[
            { id: 'EXPORT', name: 'Export' },
            { id: 'NAT IMPORT', name: 'NAT Import' },
            { id: 'PAYMENT', name: 'Payment' },
            { id: 'VMT IMPORT', name: 'VMT Import' },
            { id: 'WEB APP', name: 'Web App' }
        ]} />
       
        <DateInput source="created_date"    label="Date" locales="en-us"/>
        <SelectInput source="type" lable ='type' allowEmpty emptyValue="" choices={[
            { id: 'alert', name: 'Alert' },
            { id: 'audit', name: 'Audit' },
            { id: 'deferral', name: 'Deferral' },
            { id: 'error', name: 'Error' },
            { id: 'info', name: 'Info' },
            { id: 'lookback', name: 'Look back' },
            { id: 'reactive', name: 'Reactive' },
            { id: 'Research', name: 'Research' }
        ]} />
    </Filter>
);

export const LogList = ({ classes, ...props }) => (
    <ErrorBoundary>  
    <List 
        classess={classes}
        {...props}
        perPage={20}
        bulkActionButtons ={false}
        filters={<LogFilter />}
        title="Logs"
        >
        <Datagrid  classes={{ headerCell: classes.header }} >
            <TextField source="app"     label="Resource" />  
            <TextField source="type"    label="Type" />  
            <TextField source="message" lable="Description" />
            <TextField source="created_by" label="Created by" />
            <DateField source="created_date"    label="Date" locales="en-us"/>
        </Datagrid>
    </List>
    </ErrorBoundary>  
);


export default withStyles(listStyles)(LogList)